import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import AdTypeMenuItem from './AdTypeMenuItem';
import AdTypeMenuHeading from './AdTypeMenuHeading';
import { Partner } from '../partners/partner';

const AdTypeMainMenu = ({ partner, $state, onSelectMenu }) => {
  const navigateHome = () => {
    $state.go('creativePreview.home');
  };

  return (
    <Fragment>
      <AdTypeMenuHeading onClick={navigateHome} title="Ad Type" />
      <div className="ad-type-menu__main">
        <AdTypeMenuItem
          heading="Native"
          subheading="Create experiences in Native Display, Native ISI, Thumbnail Carousel, Full Ad Carousel, Scroller, Display RM and Video RM"
          iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/rich-media.png"
          onClick={() => {
            onSelectMenu('native');
          }}
          testId="native-submenu"
        />
        {(partner.hasAdType('native_outstream') || partner.hasAdType('instream_video')) && (
          <AdTypeMenuItem
            heading="Video"
            subheading="Generate a video unit (video file required)"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/video.png"
            onClick={() => {
              onSelectMenu('video');
            }}
            testId="video-submenu"
          />
        )}
        {partner.hasAdType('banner') && (
          <AdTypeMenuItem
            heading="Enhanced Banner"
            subheading="Create an enhanced display ad using a 300x250 banner tag"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/banner-to-native.png"
            onClick={() => {
              $state.go('creativePreview.edit.example', {
                id: 'enhancedDisplay'
              });
            }}
            testId="enhanced-display"
          />
        )}

        {partner.dco_enabled && (
          <AdTypeMenuItem
            heading="Dynamic Native"
            subheading="Build the framework ad unit for your DCO campaign"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/dynamic.png"
            onClick={() => {
              $state.go('creativePreview.edit.dynamicNative');
            }}
            testId="dynamic-native"
          />
        )}
      </div>
    </Fragment>
  );
};

AdTypeMainMenu.propTypes = {
  $state: PropTypes.object.isRequired,
  onSelectMenu: PropTypes.func.isRequired,
  partner: PropTypes.instanceOf(Partner).isRequired
};

export default AdTypeMainMenu;
